import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=bc30de1c&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=bc30de1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30de1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainSidebar: require('/build/apps/legacy/components/Layout/Sidebar/MainSidebar.vue').default,LoggedOutSidebar: require('/build/apps/legacy/components/Layout/LoggedOutSidebar.vue').default,MobileNav: require('/build/apps/legacy/components/Layout/MobileNav.vue').default,GroupHeader: require('/build/apps/legacy/components/Layout/GroupHeader.vue').default,DashboardLayoutHeader: require('/build/apps/legacy/components/Common/UI2/DashboardLayoutHeader.vue').default,SubscriptionPausedState: require('/build/apps/legacy/components/Billing/SubscriptionPausedState.vue').default})
